<template>
  <div>
    <!-- 质押仓单表格 -->
    <el-table :data="warehouseReceiptData" style="width: 100%">
      <el-table-column prop="receiptNo" label="仓单编号" width="180" align="center">
        <template slot-scope="scope">
          <a
            href="javascript:void(0)"
            class="receipt-number-link"
            @click="handleReceiptNoClick(scope.row)"
          >
            {{ scope.row.receiptNo }}
          </a>
        </template>
      </el-table-column>
      <el-table-column
        prop="cropType"
        label="粮食类型"
        width="180"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="totalQuantity"
        label="仓单总额(吨)"
        width="120"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="balanceQuantity"
        label="仓单余额(吨)"
        width="180"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="pledgeQuantity"
        label="质押数量(吨)"
        width="180"
        align="center"
      ></el-table-column>
      <el-table-column prop="warehouseCompany" label="仓储公司" align="center"></el-table-column>
    </el-table>

    <WarehouseReceiptDetailDialog
      :visible.sync="warehouseReceiptDetailDialogVisible"
      :receiptNo="selectedReceiptNo"
      :receiptId="selectedReceiptId"
    />
  </div>
</template>

<script>
import WarehouseReceiptDetailDialog from './WarehouseReceiptDetailDialog.vue'

export default {
  name: 'WarehouseReceiptDataTab',
  components: {
    WarehouseReceiptDetailDialog
  },
  props: {
    warehouseReceiptInfoList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      warehouseReceiptDetailDialogVisible: false,
      selectedReceiptNo: '',
      selectedReceiptId: '',

      // 质押仓单表格数据
      _warehouseReceiptData: [
        {
          id: '123456',
          receiptNo: 'CR202406001',
          cropType: '小麦',
          totalQuantity: 500,
          balanceQuantity: 400,
          pledgeQuantity: 100,
          warehouseCompany: '华东一号仓库'
        },
        {
          id: '123457',
          receiptNo: 'CR202406002',
          cropType: '玉米',
          totalQuantity: 300,
          balanceQuantity: 200,
          pledgeQuantity: 100,
          warehouseCompany: '华东二号仓库'
        },
        {
          id: '123458',
          receiptNo: 'CR202406003',
          cropType: '大豆',
          totalQuantity: 200,
          balanceQuantity: 100,
          pledgeQuantity: 100,
          warehouseCompany: '华南一号仓库'
        }
      ]
    }
  },
  computed: {
    warehouseReceiptData() {
      return this.mapToWarehouseReceiptData(this.warehouseReceiptInfoList)
    }
  },
  methods: {
    // 处理仓单编号点击
    handleReceiptNoClick(row) {
      console.log('点击了仓单编号:', row.receiptNo, row.id)
      this.selectedReceiptNo = row.receiptNo
      this.selectedReceiptId = row.receiptId || ''
      this.warehouseReceiptDetailDialogVisible = true
    },

    mapToWarehouseReceiptData(data) {
      return data.map(item => ({
        receiptId: item.id || '', // 仓单ID
        receiptNo: item.number || '', // 单据号
        cropType: item.grainCategoryName || '', // 粮食品种名称
        totalQuantity: item.totalWeight || 0, // 入库总重量
        balanceQuantity: item.balanceWeight || 0, // 余额重量
        pledgeQuantity: item.pledgeWeight || 0, // 质押重量
        warehouseCompany: item.companyName || '', // 仓储公司名
      }))
    }
  }
}
</script>

<style lang="less" scoped>
// 仓单编号链接样式
.receipt-number-link {
  color: #1890ff;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #40a9ff;
    text-decoration: underline;
  }
}
</style>
